/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Provider_Http_ApiInputs */



/**
* | output |
* | --- |
* | "External API" |
*
* @param {Spaces_Provider_Http_ApiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_provider_http_api = /** @type {((inputs?: Spaces_Provider_Http_ApiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Provider_Http_ApiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Externe API")
	return /** @type {LocalizedString} */ ("External API")
});